import { useState, forwardRef } from 'react';
import Tabs from '@mui/material/Tabs';
import { useLocalization } from '@ui-framework/index';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { useFormContext } from 'react-hook-form';
import CustomTabPanel from '../../CustomTabPanel';
import RuleResults from './RuleResults';
import JobStatusTable from './JobStatusTable';
import JobAuditTable from './JobAuditTable';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
  };
}

const AdditionalInfo = forwardRef((props, ref) => {
  const { formatMessage } = useLocalization();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { getValues } = useFormContext();

  const recordVersion = getValues('recordVersion');

  return (
    <Grid2 xs={12} ref={ref}>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange}>
            <Tab
              label={formatMessage({
                id: 'STATUS_AUDIT',
                defaultMessage: 'Status Audit',
              })}
              {...a11yProps(0)}
              value={0}
            />
            <Tab
              label={formatMessage({
                id: 'AUDIT_DATA',
                defaultMessage: 'Audit Data',
              })}
              {...a11yProps(1)}
              value={1}
            />
            <Tab
              label={formatMessage({
                id: 'EVENT_FEED',
                defaultMessage: 'Event Feed',
              })}
              {...a11yProps(2)}
              value={2}
            />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <JobStatusTable key={recordVersion} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <JobAuditTable key={recordVersion} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <RuleResults key={recordVersion} />
        </CustomTabPanel>
      </Box>
    </Grid2>
  );
});

export default AdditionalInfo;
